import React from 'react';
import firstLetterCaps from '../../utils/firstLetterCaps';
const Form = (props) => {
    return <form {...props}>
        <h4>{firstLetterCaps(props.title)}</h4>
        {props.children}
    </form>
}
export default Form